import React from "react";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/i18n";

const STEPS_FR = ["Découverte", "Cadrage", "Devis", "Itinéraire", "Réservations", "Carnet", "Rencontres", "Séjour", "Retour", "Récit"];
const STEPS_EN = ["Discovery", "Framing", "Quote", "Itinerary", "Bookings", "Book", "Introductions", "Stay", "Return", "Story"];

export default function Portal() {
  const { user } = useAuth();
  const { lang } = useI18n();
  const steps = lang === "fr" ? STEPS_FR : STEPS_EN;
  const currentStep = 2; // demo

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-8 pb-32">
      <div className="grid md:grid-cols-3 gap-12">
        <aside className="md:col-span-1">
          <div className="bg-white border border-[#D4AF37]/30 p-8">
            <div className="overline text-[#D4AF37]">{lang === "fr" ? "Bienvenue" : "Welcome"}</div>
            <h2 className="font-serif text-2xl text-[#0A1128] mt-2" data-testid="portal-user-name">{user?.name}</h2>
            <p className="text-sm text-[#0A1128]/60 mt-1">{user?.email}</p>
            <div className="mt-8 space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-[#0A1128]/60">{lang === "fr" ? "Rôle" : "Role"}</span><span className="text-[#0A1128]">{user?.role}</span></div>
            </div>
          </div>
        </aside>
        <main className="md:col-span-2 space-y-16">
          <section>
            <div className="overline text-[#D4AF37]">{lang === "fr" ? "Votre voyage" : "Your journey"}</div>
            <h1 className="font-serif font-light text-4xl md:text-5xl text-[#0A1128] mt-3">
              {lang === "fr" ? "Champagne Escape — Mai 2026" : "Champagne Escape — May 2026"}
            </h1>
          </section>
          <section data-testid="progress-section">
            <div className="overline text-[#0A1128]/60 mb-6">{lang === "fr" ? "Progression" : "Progress"}</div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {steps.map((s, i) => (
                <div key={s} className={`border-t pt-4 ${i <= currentStep ? "border-[#D4AF37]" : "border-[#0A1128]/15"}`}>
                  <div className={`font-serif italic ${i <= currentStep ? "text-[#D4AF37]" : "text-[#0A1128]/40"}`}>{String(i + 1).padStart(2, "0")}</div>
                  <div className={`mt-1 text-xs ${i <= currentStep ? "text-[#0A1128]" : "text-[#0A1128]/40"}`}>{s}</div>
                </div>
              ))}
            </div>
          </section>
          <section>
            <div className="overline text-[#0A1128]/60 mb-6">{lang === "fr" ? "Itinéraire" : "Itinerary"}</div>
            <div className="space-y-6">
              {[
                { d: lang === "fr" ? "Jour 1 — Arrivée à Reims" : "Day 1 — Arrival in Reims", t: lang === "fr" ? "Transfert privé depuis Paris. Check-in à L'Assiette Champenoise." : "Private transfer from Paris. Check-in at L'Assiette Champenoise." },
                { d: lang === "fr" ? "Jour 2 — Épernay & Ruinart" : "Day 2 — Épernay & Ruinart", t: lang === "fr" ? "Visite privée de Ruinart. Déjeuner au vignoble." : "Private tour of Ruinart. Vineyard lunch." },
                { d: lang === "fr" ? "Jour 3 — Vigneron secret" : "Day 3 — Secret grower", t: lang === "fr" ? "Rencontre confidentielle en Côte des Bar. Retour Paris en soirée." : "Confidential meeting in Côte des Bar. Evening return to Paris." },
              ].map((d) => (
                <div key={d.d} className="bg-white border border-[#0A1128]/10 p-6">
                  <h3 className="font-serif text-xl text-[#0A1128]">{d.d}</h3>
                  <p className="text-sm text-[#0A1128]/70 mt-2">{d.t}</p>
                </div>
              ))}
            </div>
          </section>
          <section>
            <div className="overline text-[#0A1128]/60 mb-4">{lang === "fr" ? "Documents" : "Documents"}</div>
            <div className="text-sm text-[#0A1128]/60 italic">{lang === "fr" ? "Aucun document pour l'instant." : "No documents yet."}</div>
          </section>
        </main>
      </div>
    </div>
  );
}
